import type { PermissionKey } from './permissions';
import { permissionsCopy } from '../copy/permissions';

// ---------------------------------------------------------------------------
// Pages that need one tenant permission as a whole, beside lib/planGates'
// plan table. The nav hides them from someone an admin set to No, and a
// direct URL shows a plain "no access" card rather than the page half-loading
// with refusals. Only pages where the page IS the permission belong here;
// admin-only permissions (billing, users, webhooks, prompts) aren't listed
// because their pages are admin-only already and admins are never restricted
// on the client.
// ---------------------------------------------------------------------------

export interface RoutePermission {
  /** The route and everything under it. */
  path: string;
  permission: PermissionKey;
  /** What the page says instead, e.g. "Your administrator hasn't given you access to reports." */
  noAccess: string;
}

export const ROUTE_PERMISSIONS: readonly RoutePermission[] = [
  { path: '/reports', permission: 'canViewReports', noAccess: permissionsCopy.noAccess.reports },
];

export function routePermissionFor(pathname: string): RoutePermission | undefined {
  const path = pathname.toLowerCase();
  return ROUTE_PERMISSIONS.find(g => path === g.path || path.startsWith(`${g.path}/`));
}
